import apiClient from '../../lib/axios';

export async function fetchBudgetTransactions(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') search.set(k, String(v));
  });
  const q = search.toString();
  const { data } = await apiClient.get(q ? `/api/budget-transactions?${q}` : '/api/budget-transactions');
  return data;
}

/**
 * GET /api/budget-transactions/rollup
 * groupBy is required: project | projectPeriod | objective | outcome | output | activity | accountCode | costCenter | donor | payeeType
 * Requires at least one scope: workflowId, projectId, logframeItemId
 */
export async function fetchBudgetTransactionsRollup(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') search.set(k, String(v));
  });
  const q = search.toString();
  const { data } = await apiClient.get(q ? `/api/budget-transactions/rollup?${q}` : '/api/budget-transactions/rollup');
  return data;
}

